import { render, staticRenderFns } from "./BaseApplicationCard.vue?vue&type=template&id=1126b552&scoped=true&"
import script from "./BaseApplicationCard.vue?vue&type=script&lang=js&"
export * from "./BaseApplicationCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseApplicationCard.vue?vue&type=style&index=0&id=1126b552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1126b552",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VHover,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle})
